module.exports = "<div class=\"modal-body h-100\"\r\n     class=\"documents-preview\">\r\n   <file-preview file-path=\"$ctrl.$resolve.filePath\"\r\n                 preview-type=\"$ctrl.$resolve.previewType\"\r\n                 credentials=\"$ctrl.$resolve.credentials\"></file-preview>\r\n</div>\r\n<div class=\"modal-footer\">\r\n   <rw-button variant=\"contained\"\r\n              action=\"$ctrl.close()\">\r\n      <translate>\r\n         Close\r\n      </translate>\r\n   </rw-button>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/documents/views/preview-document-dialog.html
// module id = 1277
// module chunks = 0